/*
  Quiz Result — reveal the winning ritual panel (Pause Rituals)
  Reads ?ritual=<handle> from the URL (set by the quiz on Submit) and shows the matching
  panel in each [data-ritual-group]; falls back to the first panel if none matches.
*/
(function () {
  function reveal() {
    var ritual = null;
    try {
      ritual = new URLSearchParams(window.location.search).get('ritual');
    } catch (e) {}

    document.querySelectorAll('[data-ritual-group]').forEach(function (group) {
      var panels = Array.prototype.slice.call(group.querySelectorAll('.qrp__panel'));
      if (!panels.length) return;

      var target = null;
      if (ritual) {
        panels.forEach(function (p) {
          if (p.getAttribute('data-ritual') === ritual) target = p;
        });
      }
      if (!target) target = panels[0]; // direct visit / no match → first ritual

      panels.forEach(function (p) {
        p.hidden = p !== target;
      });
    });
  }

  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', reveal);

  document.addEventListener('shopify:section:load', reveal);
})();
